import { Heading, Table } from "@biom3/react";
import type { CampaignHistory } from "../types";

export const CampaignHistoryTable = ({
  campaignHistory,
}: {
  campaignHistory: CampaignHistory[];
}) => {
  return (
    <>
      <Heading size="small" sx={{ mt: "base.spacing.x4" }}>
        Campaign history
      </Heading>
      <Table sx={{ width: "100%" }}>
        <Table.Head>
          <Table.Row>
            <Table.Cell>Name</Table.Cell>
            <Table.Cell>Ended</Table.Cell>
            <Table.Cell>Rewards Distributed</Table.Cell>
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {campaignHistory.map((campaign) => (
            <Table.Row key={campaign.id}>
              <Table.Cell>{campaign.name}</Table.Cell>
              <Table.Cell>{campaign.endDate.toLocaleDateString()}</Table.Cell>
              <Table.Cell>
                {campaign.prizeDistributed === true ? "Yes" : "No"}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  );
};
